import {useTranslation} from 'react-i18next';

import {useReservationDetails} from '@lib/store/src/ui/hooks/timeslots/useReservationDetails';
import {WorkspaceReservation} from '@lib/store/src/data/timeslots/apiTypes';
import {getGroupInvitationExpiryTime} from '@lib/utils';
import {Avatar} from '@molecules';
import {Icon} from '@atoms';
import {useModal} from '@hooks';
import {BookingDetailsCard} from 'src/components/organisms/bookWorkspace';
import {trackEvent} from '@lib/infrastructure';
import {pxToRem} from '@utils';
import {dateKeyForDateTimeString} from '@lib/store/src/data/timeslots/dateTimeHelpers';

interface Props {
  workspaceReservation: WorkspaceReservation;
  onPress?: (workspaceReservation: WorkspaceReservation) => void;
}

export const WorkspaceInvitationTile = ({workspaceReservation, onPress}: Props) => {
  const {t} = useTranslation();
  const {openModal, setModalPages} = useModal();
  const dateKey = dateKeyForDateTimeString(workspaceReservation.localStart);

  const details = useReservationDetails(workspaceReservation);
  const isFulfilled = details.status === 'fulfilled';

  const owner = isFulfilled ? details.data.find((d) => d.isOrganizer)?.owner : undefined;
  const currentMember = isFulfilled ? details.data.find((d) => d.isCurrentUser) : undefined;

  if (!owner) return null;

  return (
    <div className="w-full">
      <button
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.click();
          }
        }}
        onClick={() => {
          setModalPages([
            <BookingDetailsCard
              date={dateKey}
              workday={null}
              workspaceReservation={workspaceReservation}
            />,
          ]);

          openModal();

          trackEvent('CalendarOverview_BookingDetails__Open', {
            date: dateKey,
            isGroupBooking: true,
          });
        }}
        className="w-full p-5 pr-8 flex flex-row items-center justify-between rounded-xl bg-safe-mauve-500*">
        <div className="flex flex-row items-center gap-5">
          <Avatar
            user={owner}
            size="large"
            className="flex-shrink-0"
          />

          <div className="flex flex-col">
            <p className="font-semibold text-white">Group booking invite</p>

            <p className="mt-1 text-safe-mauve-100">by {owner?.name}</p>

            {currentMember?.reservation?.expiryDate && (
              <p className="mt-1 text-safe-mauve-100">
                {getGroupInvitationExpiryTime(t, currentMember.reservation.expiryDate)}
              </p>
            )}
          </div>
        </div>

        <Icon
          icon="caretRight"
          className="text-white"
          color="currentColor"
          size={pxToRem(24)}
        />
      </button>
    </div>
  );
};
